<template>
    <div id="component-loader">
        <div class="spinner">
            <div class="dot1"></div>
            <div class="dot2"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Component_Loader",
    components: {
        
    },
    data: () => ({

    }),
    methods: {

    }
}
</script>